import { jsx as _jsx } from "react/jsx-runtime";
import styles from './SentinelPriorityMessage.module.css';
const SentinelPriorityMessage = ({ children, level = 'regular', }) => {
    return (_jsx("span", Object.assign({ className: `${styles[(level || 'regular').toLowerCase()]}` }, { children: children }), void 0));
};
export default SentinelPriorityMessage;
